// extracted by mini-css-extract-plugin
module.exports = {"reviews__wrapper":"bc_bv","reviews__wrapper__list":"bc_d9","reviewSlider":"bc_fb"};